import defaultPostTypeConfig from '../post'
import capitalize from '../../utils/capitalize'

export default function getConstants(p = {}) {

    const name = 'apply'

    const n = name
    const N = capitalize(n)
    const ns = (name.endsWith('y')) ? name.slice(0, -1) + 'ies' : name + 's'
    const Ns = capitalize(ns)

    const {
        labels,
        menus,
        messages,
        routes,
        titles
    } = defaultPostTypeConfig.getConstants({
        ...p,
        name
    })

    // a szövegbe szúrt változó-nevek (szakma, készségek, nyelvek) TELJES KISBETŰVEL (közönséges főnevek; a
    // taxonómia-címekben a második szó is lehet nagybetűs, pl. "Reggeliztető Szakács"). A jelölt keresztnevét és
    // a mondatkezdő szót nem érinti (azokat külön kezeljük / mondat elején állnak).
    const lc = (s) => (s && typeof s === 'string') ? s.toLowerCase() : s
    const lcList = (arr) => (Array.isArray(arr) ? arr.map(lc) : [])

    return {
        labels: {
            ...labels,
            ['new' + N + 'SubmitLabel']: 'Jelentkezem az állásra',
            ['restore' + N + 'SubmitLabel']: 'Visszaállítás',
            ['save' + N + 'SubmitLabel']: 'Mentés',
            ['cancel' + N + 'Text']: 'Mégsem',
            ['delete' + N + 'Text']: 'Törlés',
            ['delete' + Ns + 'Text']: 'Jelentkezések törlése',
            ['ban' + N + 'Text']: 'Tiltás',
            ['approve' + N + 'Text']: 'Jóváhagyás',
            ['protection' + N + 'Text']: 'Védettnek jelölés',
            ['removeProtection' + N + 'Text']: 'Védettség megszüntetése',
            ['select' + N + 'Text']: 'Kiválasztás',
            ['add' + N + 'Text']: 'Hozzáadás',
            ['moreFromMy' + Ns + 'Title']: 'További jelentkezéseim',
            ['moreFromUser' + Ns + 'Title']: 'További jelentkezések',

            [ns + 'SortRelevance']: 'Relevancia',

            [n + 'MarkIrrelevant']: 'Törlés',
            [n + 'RemoveMarkIrrelevant']: 'Visszaállítás',
            [n + 'AppliesForMeTrash']: 'Törölt jelentkezések',
            [n + 'AppliesForMeBanned']: 'Lejárt jelentkezések',
            [n + 'AvatarSecondaryTextProfile']: 'Profil megtekintése',

            [n + 'AllLabel']: 'Összes',
            [n + 'OtherFilters']: 'További szűrők',

            // jelentkezés-nézetek tab-jai + HR-asszisztens job-választó
            [n + 'TabForMe']: 'Jelentkezések',
            [n + 'TabForMeAll']: 'Összes jelentkezés',
            [n + 'TabHrAssistant']: 'HR asszisztens',
            [n + 'TabFavorites']: 'Kedvencek',
            [n + 'TabDeleted']: 'Törölt',
            [n + 'TabBanned']: 'Lejárt',

            // kedvenc-jelölés (szív) menü-akciók
            [n + 'AddFavorite']: 'Kedvencekhez adás',
            [n + 'RemoveFavorite']: 'Eltávolítás a kedvencekből',
            [n + 'JobSelectPlaceholder']: 'Válassz egy hirdetést',
            [n + 'HrAssistantAnalyzing']: 'Jelöltek feldolgozása',
            // buborék az analizálás alatt, ha még sok (>3) önéletrajz van hátra — hosszabb várakozásnál megnyugtató üzenet
            [n + 'HrAssistantAnalyzingHint']: 'Az elemzés eltarthat egy ideig, nyugodtan folytasd a munkát és nézz vissza pár perc múlva.',
            // INTRÓ / jóváhagyás a feldolgozás ELŐTT (nem automatikus): az AI bemutatkozik + a munkáltató indítja
            [n + 'HrAssistantIntro']: 'Szia,\n\na Karrier Hub HR asszisztense vagyok, és abban segítek, hogy megkönnyítsem a döntésedet: sorba rendezem a jelentkezőket aszerint, hogy ki a legalkalmasabb erre a hirdetésre. Ehhez átnézem az önéletrajzokat és a profilokat, majd értékelek. Fontos: az AI tévedhet, a végső döntés a tiéd marad - a lényeges adatokat érdemes ellenőrizned.\n\nElkezdhetem?',
            [n + 'HrAssistantStart']: 'Kezdheted',

            // nézet-váltó fülek + az Összefoglaló (infografika) nézet szövegei
            [n + 'HrTabSummary']: 'Összefoglaló',
            [n + 'HrTabList']: 'Lista',
            [n + 'HrSummaryHeading']: 'A legjobb jelöltek',
            [n + 'HrSummaryEmpty']: 'Nincs megjeleníthető jelölt.',
            [n + 'HrSummaryLoading']: 'Betöltés…',
            [n + 'HrSummaryClose']: 'Bezárás',

            // HR-asszisztens sort-legördülő labelek (a rendezési szempontok nevei). A kártya-badge-ek NEM innen,
            // hanem szerver-oldali featuredChildren-ből jönnek (server constants Dim*: 'Szakmailag legerősebb' stb.).
            // A kulcs = n + 'Dim' + a dimenzió-kulcs nagy kezdőbetűvel (pl. applyDimPositionfit)
            [n + 'DimMatch']: 'Legjobb találat',
            [n + 'DimPositionfit']: 'Szakmai alkalmasság',
            [n + 'DimExperience']: 'Tapasztalat szerint',
            [n + 'DimQualification']: 'Képzettség szerint',
            [n + 'DimSoftskill']: 'Készségek szerint',
            [n + 'DimDistance']: 'Legközelebbi',
            [n + 'DimRecent']: 'Legfrissebb',
            [n + 'HrAssistantNoData']: 'Nincs elég adat',

            // HR-kártya dimenzió-chart + a két szekció címe (elemzés + önéletrajz-kivonat egy oldalon)
            [n + 'MatchTotalLabel']: 'Összpontszám',
            [n + 'AnalysisTitle']: 'Elemzés',
            [n + 'CvSummaryTitle']: 'Önéletrajz rövid összefoglalója',

            // a chart módosító-sorai + a nézet-toggle
            [n + 'MatchAdjustGate']: 'Elvárás hiánya miatt',
            [n + 'MatchAdjustFloor']: 'Szakmai minimum',
            [n + 'MatchAdjustClampHigh']: 'Felső korlát',
            [n + 'MatchAdjustClampLow']: 'Alsó korlát',
            [n + 'MatchAdjustRounding']: 'Kerekítés',
            [n + 'AnalysisViewAll']: 'Bővebben (minden tényező)',
            [n + 'AnalysisViewRelevant']: 'Csak a relevánsak',

            // Találati beállítások (setup a lista fölött) — első, vizuális verzió. A munkáltató finomíthatja,
            // mit mennyire vegyünk figyelembe; az alapértékeket a hirdetésből olvassuk ki (bekötés következő lépés).
            [n + 'MatchSetupTitle']: 'Beállítások',

            // figyelmeztető/info-box a beállítások FÖLÖTT (kattintható → módszertan-oldal nyílik dialógusban)
            [n + 'MatchSetupInfoContent']: 'A HR asszisztens hibázhat, fontold meg a fontos információk ellenőrzését. Az elemzés módszertanáról itt olvashatsz bővebben.',
            [n + 'MatchSetupInfoSlug']: 'hr-asszisztens-modszertan',
            [n + 'MatchSetupInfoClose']: 'Bezárás',

            // HR-asszisztens info-box (plazma-logó + gépelő, VÁLTAKOZÓ mondatok). A HrAssistantInfoBox az InfoN kulcsokat
            // sorban összeszedi (1..N, amíg van), és felváltva kigépeli. A dobozra kattintva a módszertan-oldal nyílik.
            [n + 'HrAssistantInfoTitle']: 'Felelős használat',
            [n + 'HrAssistantInfo1']: 'A HR asszisztens a rangsorolást gyorsítja, nem hoz döntést helyetted.',
            [n + 'HrAssistantInfo2']: 'Az AI tévedhet, ezért a fontos adatokat ellenőrizd az önéletrajzban és egyeztesd a jelölttel.',
            [n + 'HrAssistantInfo3']: 'A pontszám nem helyettesíti az emberi mérlegelést, sem a jogszabályi (pl. esélyegyenlőségi, adatvédelmi) követelmények betartását.',
            [n + 'HrAssistantInfo4']: 'Az elemzés módszertanáról ide kattintva olvashatsz bővebben.',

            [n + 'MatchSetupExpectedPrefix']: 'Elvárt: ',
            [n + 'MatchSetupRecalc']: 'Újraszámítás',
            [n + 'MatchSetupReset']: 'Visszaállítás',
            // táblázat oszlop-fejlécek
            [n + 'MatchSetupColDimension']: '',
            [n + 'MatchSetupColExpected']: 'Elvárt érték',
            [n + 'MatchSetupColBonus']: 'Előny',
            [n + 'MatchSetupColWeight']: 'Súly',
            [n + 'MatchSetupColRequired']: 'Elvárás',
            [n + 'MatchSetupRequiredLabel']: 'Elvárt',
            // legördülő placeholderek (az optionsKey alapján: MatchSetupPlaceholder<Cap(optionsKey)>)
            [n + 'MatchSetupPlaceholderYears']: 'Válassz évet',
            [n + 'MatchSetupPlaceholderMaxYears']: 'Válassz évet',
            [n + 'MatchSetupPlaceholderProfession']: 'Válassz szakmát',
            [n + 'MatchSetupPlaceholderQualificationAccepted']: 'Elfogadható végzettségek',
            [n + 'MatchSetupPlaceholderQualification']: 'Válassz végzettségeket',
            [n + 'MatchSetupPlaceholderLanguage']: 'Válassz nyelveket',
            [n + 'MatchSetupPlaceholderSoftskill']: 'Válassz készségeket',
            [n + 'MatchSetupPlaceholderAgeMin']: 'Min. kor',
            [n + 'MatchSetupPlaceholderAgeMax']: 'Max. kor',
            [n + 'MatchSetupPlaceholderGender']: 'Válassz nemet',
            // súly-szintek (a fontosság — a "kötelező" külön oszlop)
            [n + 'MatchWeightLess']: 'Kevésbé számít',
            [n + 'MatchWeightNice']: 'Jó ha van',
            [n + 'MatchWeightImportant']: 'Fontos',
            [n + 'MatchWeightVeryImportant']: 'Nagyon fontos',
            // faktoronkénti kis magyarázó
            [n + 'MatchExplainPositionfit']: 'Releváns szakmai tapasztalat',
            [n + 'MatchExplainExperience']: 'Mennyire legyen rutinos a jelentkező?',
            [n + 'MatchExplainQualification']: 'Milyen végzettség elvárt?',
            [n + 'MatchExplainLanguage']: 'Milyen nyelv szükséges a szakma betöltéséhez?',
            [n + 'MatchExplainSoftskill']: 'Milyen készségeket részesít előnyben?',
            [n + 'MatchExplainLicense']: 'Szükséges jogosítvány?',
            [n + 'MatchExplainDistance']: 'Távoli jelentkezők hátrányban',
            [n + 'MatchExplainAge']: 'A korosztály számít-e?',
            [n + 'MatchExplainGender']: 'A jelentkező neme számít-e?',
            // "magasabb szint előny" checkbox feliratai
            [n + 'MatchBonusPositionfit']: 'Magasabb szakmai szint előny',
            [n + 'MatchBonusQualification']: 'Magasabb végzettség előny',
            // a 4-fokozatú "mennyire számít"
            [n + 'MatchImpIgnore']: 'Nem számít',
            [n + 'MatchImpNice']: 'Jó ha van',
            [n + 'MatchImpImportant']: 'Fontos',
            [n + 'MatchImpRequired']: 'Kötelező',
            // faktor-nevek a setupban
            [n + 'MatchFactorPositionfit']: 'Szakmai alkalmasság',
            [n + 'MatchFactorExperience']: 'Tapasztalat',
            [n + 'MatchFactorQualification']: 'Végzettség',
            [n + 'MatchFactorLanguage']: 'Nyelv',
            [n + 'MatchFactorSoftskill']: 'Készségek',
            [n + 'MatchFactorLicense']: 'Jogosítvány',
            [n + 'MatchFactorDistance']: 'Távolság',
            [n + 'MatchFactorAge']: 'Kor',
            [n + 'MatchFactorGender']: 'Nem',

            // a chart-sávok fölötti rövid magyarázat (mit mér + a küszöb): a "miért kapott annyit". A value adja a
            // konkrét számot. Ahol küszöb kell (Szakértő/Rutinos), függvény-konstans a meta-ból (mint a GetEmployeeName)
            [n + 'DimExplainPositionfit']: (d, name) => {
                const who = name || 'A jelölt'
                const req = (d && d.required) || 3
                const yrs = (d && typeof d.years === 'number') ? d.years : 0
                const head = (d && d.profession)
                    ? ('A meghirdetett ' + lc(d.profession) + ' szakmában szerzett tapasztalat szerint ')
                    : 'A meghirdetett szakmában szerzett tapasztalat szerint '
                const reqNote = (d && d.reqSpecified)
                    ? ('a hirdetés ' + req + ' évet vár el')
                    : ('a pozíció betöltéséhez ' + req + ' év szakmai tapasztalat szükséges (a hirdetésben nincs megadott év a tapasztalathoz, ezért a rendszer ' + req + ' évet számít)')
                let verdict
                if (yrs <= 0) {
                    // a "szakmájával lefed" CSAK akkor, ha tényleg van pozíció-illés (a jelölt szakmája a meghirdetett/rokon)
                    verdict = (d && d.match)
                        ? ', amit ' + who + ' a szakmájával lefed (konkrét évszám nincs megadva)'
                        : ', de ' + who + ' a meghirdetett szakmában nem rendelkezik tapasztalattal'
                } else if (yrs >= req) {
                    verdict = ', amit ' + who + ' ' + yrs + ' évével teljesít'
                } else {
                    verdict = ', amit ' + who + ' ' + yrs + ' évével nem teljesít'
                }
                let s = head + reqNote + verdict + '.'
                // a "magasabb szintre jutott, ami tovább emeli" CSAK akkor, ha a szenioritás TÉNYLEGESEN emelt a ponton
                // (seniorBonus). Ha az alap már plafonon van (a boost elveszik), ne állítsuk a növelést.
                if (d && d.seniorBonus) {
                    s += ' ' + who + ' a szakmájában magasabb szintre jutott, ami tovább emeli pontszámát.'
                }
                return s
            },
            [n + 'DimExplainExperience']: (d, name) => {
                const who = name || 'A jelölt'
                const yrs = (d && typeof d.years === 'number') ? d.years : 0
                if (yrs <= 0) {
                    return who + ' nem rendelkezik kimutatható szakmai tapasztalattal.'
                }
                const sat = (d && d.saturation) || 8
                const rutinos = yrs >= (sat / 2)
                return who + ' összes szakmai tapasztalata ' + yrs + ' év, ezért ' + (rutinos ? 'rutinosnak számít.' : 'még nem számít rutinosnak.')
            },
            [n + 'DimExplainQualification']: (d, name) => {
                const who = name || 'A jelölt'
                const all = lcList((d && Array.isArray(d.allNames)) ? d.allNames : [])           // jelölt ÖSSZES végzettsége (CV)
                const expected = lcList((d && Array.isArray(d.requiredNames)) ? d.requiredNames : []) // hirdetés elvárt végzettségei
                const met = !!(d && d.met)
                // a jelölt végzettségei az önéletrajzból
                const candPart = all.length
                    ? (who + ' önéletrajzában ' + all.join(', ') + (all.length > 1 ? ' végzettségek vannak' : ' végzettség van'))
                    : (who + ' önéletrajzában nincs megadott végzettség')

                // nem volt elvárás → nem számít bele
                if (d && d.counts === false) {
                    return candPart + ', de a hirdetés nem várt el végzettséget, ezért ez nem számít bele az összpontszámba' +
                        (all.length ? ' (egyébként növelte volna).' : '.')
                }

                // VAGY-kapcsolat: az elvárt szint VAGY bármelyik elfogadott/releváns szakképesítés megléte elég.
                // A nevet ZÁRÓJELBE tesszük (nem ragozzuk), így a "felsőfokú végzettség" sem lesz dupla; egyes/többes külön.
                const expPart = (expected.length > 1)
                    ? ('a hirdetésben elfogadható végzettségek valamelyikének (' + expected.join(', ') + ')')
                    : (expected.length === 1
                        ? ('a hirdetésben elfogadható végzettségnek (' + expected[0] + ')')
                        : 'a hirdetés által elvárt végzettségnek')
                return met
                    ? (candPart + ', ami alapján megfelel ' + expPart + ', ezért ez emeli a pontszámát.')
                    : (candPart + ', ami alapján nem felel meg ' + expPart + ', ezért ez a pont alacsonyabb.')
            },
            [n + 'DimExplainSoftskill']: (d, name) => {
                const who = name || 'A jelölt'
                if (d && d.counts === false) {
                    const cnt = (d && typeof d.count === 'number') ? d.count : 0
                    const tail = (cnt > 0)
                        ? (who + ' megadott készségeket, ami egyébként növelte volna a pontszámot.')
                        : (who + ' nem adott meg készségeket.')
                    return 'A hirdetés nem emelt ki konkrét készséget, ezért ez nem számít bele az összpontszámba. ' + tail
                }
                const req = lcList((d && Array.isArray(d.requiredNames)) ? d.requiredNames : [])
                const got = lcList((d && Array.isArray(d.matchedNames)) ? d.matchedNames : [])
                if (!req.length) {
                    return 'A hirdetés nem emel ki konkrét készséget, ezért ez a pont semleges.'
                }
                const head = 'A hirdetés ezeket a készségeket emeli ki: ' + req.join(', ') + '.'
                if (!got.length) {
                    return head + ' ' + who + ' önéletrajzában egyik sem azonosítható, ezért nem passzol eléggé a megadott tulajdonságokhoz.'
                }
                const ratio = got.length / req.length
                const verdict = (ratio >= 1) ? 'teljesen illik' : ((ratio >= 0.5) ? 'nagyjából passzol' : 'nem passzol eléggé')
                return head + ' ' + who + ' önéletrajza szerint ' + got.join(', ') + ' jellemzi őt, tehát ' + verdict + ' a hirdetésben megadott tulajdonságokhoz.'
            },
            [n + 'DimExplainLanguage']: (d, name) => {
                const who = name || 'A jelölt'
                if (d && d.counts === false) {
                    const cnt = (d && typeof d.count === 'number') ? d.count : 0
                    const tail = (cnt > 0)
                        ? (who + ' beszél nyelve(ke)t, ami egyébként növelte volna a pontszámot.')
                        : (who + ' nem adott meg nyelvtudást.')
                    return 'A pozícióhoz nem volt kötelező nyelvtudás, ezért ez nem számít bele az összpontszámba. ' + tail
                }
                const req = lcList((d && Array.isArray(d.requiredNames)) ? d.requiredNames : [])
                const got = lcList((d && Array.isArray(d.matchedNames)) ? d.matchedNames : [])
                if (!req.length) {
                    return 'A pozíció betöltéséhez nincs megadva kötelező nyelvtudás, ezért ez a pont semleges.'
                }
                const head = 'A pozíció betöltéséhez elvárt nyelvtudás: ' + req.join(', ') + '.'
                if (!got.length) {
                    return head + ' ' + who + ' egyik kért nyelvet sem beszéli, ezért nem felel meg az elvárásnak.'
                }
                const ok = got.length >= req.length
                return head + ' ' + who + ' ' + got.join(', ') + ' nyelvet beszél, ezért ' + (ok ? 'megfelel' : 'nem felel meg teljesen') + ' az elvárásnak.'
            },
            [n + 'DimLanguage']: 'Nyelv',

            [n + 'BannedEmployeeChipLabel']: 'Letiltott felhasználó',
            [n + 'BanEmployeeMenuLabel']: 'Felhasználó tiltása',
            [n + 'BanEmployeeDialogTitle']: 'Felhasználó tiltása',
            [n + 'BanEmployeeDialogContent']: 'Biztosan letiltja ezt a jelentkezőt? A jövőben nem fogja látni az ő jelentkezéseit, és nem kap róla értesítést sem.',
            [n + 'BanEmployeeSubmit']: 'Tiltás',

            [name + 'ShowInfoTitle']: '',

            ['preview' + N + 'EmployeeCvDocument']: 'Önéletrajz megtekintése'
        },
        menus: {
            ...menus,
            ['user' + Ns + 'Menu']: 'Jelentkezések',
            ['my' + Ns + 'Menu']: 'Jelentkezéseim',
            ['new' + N + 'Menu']: 'Új jelentkezés',
            [ns + 'Menu']: 'Jelentkezések',

            ['my' + Ns + 'ForMeMenu']: 'Jelentkezők',
            ['user' + Ns + 'ForMeMenu']: 'Jelentkezők',

            ['my' + Ns + 'HrAssistantMenu']: 'HR asszisztens',
            ['user' + Ns + 'HrAssistantMenu']: 'HR asszisztens',

            ['my' + Ns + 'FavoritesMenu']: 'Kedvenc jelentkezések',
            ['user' + Ns + 'FavoritesMenu']: 'Kedvenc jelentkezései',

            ['my' + Ns + 'FormeDeletedMenu']: 'Törölt jelentkezések',
            ['user' + Ns + 'FormeDeletedMenu']: 'Törölt jelentkezései',

            ['deleted' + Ns + 'Menu']: 'Törölt jelentkezések',
            ['banned' + Ns + 'Menu']: 'Lejárt jelentkezések',
            ['protection' + Ns + 'Menu']: 'Védett jelentkezések',
            ['missingData' + Ns + 'Menu']: 'Hiányzó adatok',
            ['lowAuthorStatus' + Ns + 'Menu']: 'Szerző alacsony státusszal',
            ['edit' + N + 'Menu']: 'Szerkesztés',
            ['delete' + N + 'Menu']: 'Törlés',
            ['ban' + N + 'Menu']: 'Tiltás',
            ['approve' + N + 'Menu']: 'Jóváhagyás',
            ['protection' + N + 'Menu']: 'Védettnek jelölés',
            ['removeProtection' + N + 'Menu']: 'Védettség törlése'


        },
        messages: {
            ...messages,
            ['new' + N + 'SuccessMessage']: 'Jelentkezésedet rögzítettük',
            ['newExternal' + N + 'SuccessMessage']: 'Átirányítottunk a jelentkezés oldalra',
            ['save' + N + 'SuccessMessage']: 'A jelentkezés mentésre került',
            ['delete' + N + 'Success']: 'A jelentkezés törölve lett',
            ['delete' + Ns + 'Success']: 'A jelentkezések törölve lettek',
            ['delete' + N + 'Question']: 'Biztosan törli a jelentkezést?',
            ['delete' + Ns + 'Question']: 'Biztosan törli a jelentkezéseket?',
            ['ban' + N + 'Success']: 'A jelentkezés véglegesen törölve lett',
            ['ban' + N + 'Question']: 'Biztos, hogy a jelentkezést véglegesen törölni akarod?',
            ['approve' + N + 'Success']: 'A jelentkezés jóvá lett hagyva',
            ['approve' + N + 'Question']: 'Biztosan jóváhagyod a jelentkezést',
            ['protection' + N + 'Success']: 'A jelentkezés védettnek jelölve',
            ['protection' + N + 'Question']: 'Biztosan védettnek jelölöd a jelentkezést?',
            ['removeProtection' + N + 'Success']: 'A védettnek jelölés törölve lett',
            ['removeProtection' + N + 'Question']: 'Biztosan törlöd a védettnek jelölést?',
            ['thereAreNo' + Ns]: 'Nincsenek jelentkezések',
            [n + 'HrAssistantSelectJob']: 'Válassz egy hirdetést a jelentkezők elemzéséhez',

            [n + 'MarkIrrelevantSuccessMessage']: 'A jelentkezés törölve lett',
            [n + 'RemoveMarkIrrelevantSuccessMessage']: 'A jelentkezés vissza lett állítva',
            [n + 'AddFavoriteSuccess']: 'Hozzáadva a kedvencekhez',
            [n + 'RemoveFavoriteSuccess']: 'Eltávolítva a kedvencekből',
            [n + 'NotFoundNotAvailable']: (p = {}) => {
                const { user } = p
                return user?._id ? 'Ez a jelentkezés már nem elérhető' : 'Lépj be, hogy megtekinthesd a jelentkezést'
            },

            [n + 'ShowInfoContent']: 'Ahhoz, hogy láthasd a hirdetés elérhetőségeit, előbb küldd el a jelentkezésed!',

            [n + 'NewExternalInfo']: `A hirdetés feladója a saját oldalán várja a jelentkezéseket, ezért a "Jelentkezem az állásra" gomb megnyomásával átirányítunk a hirdető által megadott oldalra, ahol kitöltheted a jelentkezésedet`

        },
        routes: {
            ...routes
        },
        titles: {
            ...titles,
            [n + 'Title']: 'Jelentkezés',
            [ns + 'Title']: 'Jelentkezések',
            ['new' + N + 'Title']: 'Új jelentkezés',
            ['edit' + N + 'Title']: 'Jelentkezés szerkesztése',
            ['user' + Ns + 'Title']: 'Jelentkezések',
            ['userDeleted' + Ns + 'Title']: 'Törölt jelentkezések',
            ['userBanned' + Ns + 'Title']: 'Lejárt jelentkezések',
            ['my' + Ns + 'Title']: 'Jelentkezéseim',
            ['myDeleted' + Ns + 'Title']: 'Törölt jelentkezéseim',
            ['myBanned' + Ns + 'Title']: 'Lejárt jelentkezéseim',

            ['user' + Ns + 'ForMeTitle']: 'Jelentkezések a hirdetéseire',
            ['my' + Ns + 'ForMeTitle']: 'Jelentkezések a hirdetéseimre',

            ['user' + Ns + 'HrAssistantTitle']: 'HR asszisztens',
            ['my' + Ns + 'HrAssistantTitle']: 'HR asszisztens',

            ['user' + Ns + 'FavoritesTitle']: 'Kedvenc jelentkezések',
            ['my' + Ns + 'FavoritesTitle']: 'Kedvenc jelentkezések',

            ['user' + Ns + 'ForMeDeletedTitle']: 'Jelentkezések a hirdetéseire',
            ['my' + Ns + 'ForMeDeletedTitle']: 'Jelentkezések a hirdetéseimre',

            ['user' + Ns + 'ForMeBannedTitle']: 'Jelentkezések a hirdetéseire',

            ['dialogDelete' + N + 'Title']: 'Jelentkezés törlése',
            ['dialogBan' + N + 'Title']: 'Jelentkezés törlése véglegesen',
            ['dialogApprove' + N + 'Title']: 'Jelentkezés jóváhagyása',
            ['dialogProtection' + N + 'Title']: 'Jelentkezés védettnek jelölése',
            ['dialogRemoveProtection' + N + 'Title']: 'Jelentkezés védettségének megszüntetése',

            ['dialogDelete' + Ns + 'Title']: 'Jelentkezések törlése',

            ['statusBanned' + N + 'Title']: 'Lejárt',
            ['statusDeleted' + N + 'Title']: 'Törölt',
            ['statusAuthorDeleted' + N + 'Title']: 'Szerző törölve',
            ['statusMissingData' + N + 'Title']: 'Hiányzó adatok',
            ['statusApproved' + N + 'Title']: 'Jóváhagyott',
            ['statusFeatured' + N + 'Title']: 'Védett',
            ['statusCreated' + N + 'Title']: 'Létrehozva',

            ['banned' + Ns + 'Title']: 'Lejárt jelentkezések',
            ['deleted' + Ns + 'Title']: 'Törölt jelentkezések',
            ['missingData' + Ns + 'Title']: 'Hiányzó adatok',
            ['protected' + Ns + 'Title']: 'Védett jelentkezések',
            ['lowAuthorStatus' + Ns + 'Title']: 'Szerző alacsony státusszal',

            ['select' + Ns]: 'Jelentkezések kiválasztása',
            ['select' + N]: 'Jelentkezés kiválasztása'

        }
    }
}
